import HeroSection from "components/Applications/HeroSection";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import OrgAdminDashboardWrapper from "components/lib/Global/OrgAdminDashboardWrapper";
import Organizations from "components/SystemAdminDashboard/Organizations";
import React from "react";
import GoBackToHomeBtn from "../GoBackToHomeBtn";
import Sidebar from "components/Applications/Sidebar";
import Cookie from "js-cookie";
import { Constants } from "config/constants";
import Unauthorized from "pages/Unauthorized";

const OrgAdmins = () => {
  const role = Cookie.get("role");

  if (role !== Constants.COOKIE_ROLES.SUPER_ADMIN) {
    return <Unauthorized />;
  }

  return (
    <div>
      <OrgAdminDashboardWrapper>
        <HeroSection />
        <GoBackToHomeBtn />
        <div className="grid grid-cols-6 border-t border-gray">
          <div className="col-span-6 pr-8 md:col-span-1">
            <Sidebar />
          </div>
          <div className="col-span-6 md:border-l md:col-span-5 md:pl-8 pt-8 border-gray">
            <Organizations isSuperAdmin={true} />
          </div>
        </div>
      </OrgAdminDashboardWrapper>
    </div>
  );
};

export default OrgAdmins;
